import { IUser } from "@vmosolutions/oc-interfaces";
import { AcknowledgementRole } from "./acknowledgementState";
import {AcknowledgedUser} from "./acknowledgementState";

const TOOLTIP_COPY: Record<AcknowledgementRole, { acknowledgedPrefix: string; awaitingMessage: string }> = {
  own: {
    acknowledgedPrefix: "Sent by you - acknowledged by",
    awaitingMessage: "Sent by you - awaiting acknowledgement",
  },
  dispatcher: {
    acknowledgedPrefix: "Sent by another dispatcher - acknowledged by",
    awaitingMessage: "Sent by another dispatcher - awaiting crew acknowledgement",
  },
  crew: {
    acknowledgedPrefix: "Crew message - acknowledged by",
    awaitingMessage: "Crew message - not acknowledged",
  },
};

/**
 * Builds the acknowledgement-status tooltip text. When the message has acknowledgements,
 * each acknowledger's name is listed on its own line.
 * 
 * @param role - The role of the message (own, dispatcher, or crew).
 * @param acknowledgedUsers - An array of users who have acknowledged the message.
 * @param getUserName - A function that takes an acknowledged user and returns their display name.
 * 
 * @returns A string to be used as the content of the acknowledgement tooltip
 */
export function buildAcknowledgementTooltip(
  role: AcknowledgementRole, 
  acknowledgedUsers: AcknowledgedUser[], 
  getUserName: (user: AcknowledgedUser) => string): string {
  const { acknowledgedPrefix, awaitingMessage } = TOOLTIP_COPY[role];

  if (acknowledgedUsers.length === 0) return awaitingMessage;

  const names = acknowledgedUsers.map(getUserName).join(",\n");
  return `${acknowledgedPrefix}:\n${names}`;
}
